import React from 'react';
import axios from 'axios';

class ProductImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      imageUrl: '',
    };
  }

  componentDidMount() {
    this.getImage(this.props.product);
  }

  getImage(product) {
    axios({
      url: `/products/${product}.json`,
      method: 'GET',
    })
      .then((response) => {
        const rawImageUrl = response.data.product.image.src;
        const filteredImgUrl = rawImageUrl.replace(
          /(\.[^\.]+)$/,
          '_205x205_crop_center$1'
        );
        this.setState({ imageUrl: filteredImgUrl });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    return <img src={this.state.imageUrl} />;
  }
}

export default ProductImage;
